export default __webpack_public_path__ + "static/media/Email.2ec00ca3.svg";